import React, { useState } from "react";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// interface
import { BasicDetailsTypes } from "../../../data/myProfile";
import { Utils } from "helpers/utils";
import UserAvatar from "components/UserAvatar";
import { APIClient } from "api/apiCore";
import { useRedux } from "hooks";
import { getCurrentUserAction } from "../../../redux/profile2/p2_reducer";
import UserProfileModal from "components/UserProfileModal";

interface MyProfileProps {
  basicDetails: BasicDetailsTypes;
}
const MyProfile = ({ basicDetails }: MyProfileProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // console.log('basicDetails:', basicDetails);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handleImageClick = () => {
    if (Utils.IsViewAsAlert()) return false;
    // Trigger file input click
    document.getElementById("fileInput")?.click();
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Call API to upload the image
      // const formData = new FormData();
      // formData.append("profilePicture", file);

      try {
        const api = new APIClient();
        var resp = await api.p2ChangeImage(file);
        dispatch(getCurrentUserAction());

        // console.log(resp);

        // const response = await fetch("/api/upload-profile-picture", {
        //   method: "POST",
        //   body: formData,
        // });

        // if (response.ok) {
        //   const updatedImageUrl = await response.json();
        //   //setImageUrl(updatedImageUrl);
        // } else {
        //   console.error("Failed to upload the image");
        // }
      } catch (error) {
        console.error("An error occurred while uploading the image", error);
      }
    }
  };

  const fullName = basicDetails
    ? `${basicDetails.firstName} ${basicDetails.lastName}`
    : "-";

  const fullNameShort = fullName.length > 30 ? ( fullName.substring(0, 30) + "...") : fullName;
  
  const [userProfileModalOpen, setUserProfileModalOpen] = useState<boolean>(false);
  const userProfileModalOnClose = () => {
    setUserProfileModalOpen(prev => !prev);
  }
  return (
    <>
      <div className="user-profile-img">
        {basicDetails && basicDetails.coverImage && (
          <img
            src={basicDetails.coverImage}
            className="profile-img"
            style={{ height: "160px" }}
            alt=""
          />
        )}

        <div className="overlay-content">
          <div>
            <div className="user-chat-nav p-2 ps-3">
              <div className="d-flex w-100 align-items-center">
                <div className="flex-grow-1">
                  <h5 className="text-white mb-0">ข้อมูลส่วนตัว</h5>
                </div>
                <div className="flex-shrink-0">

                  <Dropdown isOpen={dropdownOpen} toggle={toggle} >

                    <DropdownToggle
                      color="none"
                      className="btn nav-btn text-white"
                      type="button"

                    >
                      <i className="bx bx-dots-vertical-rounded"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-start" >
                      <DropdownItem
                        className="d-flex align-items-center justify-content-between"
                        href="#"
                      >
                        Info{" "}
                        <i className="bx bx-info-circle ms-2 text-muted"></i>
                      </DropdownItem>
                      <DropdownItem
                        className="d-flex align-items-center justify-content-between"
                        href="#"
                      >
                        Setting <i className="bx bx-cog text-muted ms-2"></i>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        className="d-flex align-items-center justify-content-between"
                        href="#"
                      >
                        Help{" "}
                        <i className="bx bx-help-circle ms-2 text-muted"></i>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="text-center p-3 p-md-4 border-bottom pt-2 pt-md-2 mt-n5 position-relative ">
        <div className="mb-md-3 mb-2 ">
          {basicDetails && basicDetails.coverImage && (
            <>
              <img
                src={basicDetails.avatar}
                className="rounded-circle avatar-lg img-thumbnail"
                alt=""
                onClick={handleImageClick}
              />
              {/* Hidden file input */}
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </>
          )}
        </div>

        <h5 className="font-size-16 mb-1 text-truncate">
          {fullNameShort}
          &nbsp;<i className="edit-icon" onClick={userProfileModalOnClose}></i>
        </h5>
        <p className="text-muted font-size-14 text-truncate mb-0">
          <span className="mdi mdi-phone"></span>
          {basicDetails && basicDetails.title ? Utils.FormatPhoneNo10(basicDetails.title) : "-"}
        </p>
      </div>
      <UserProfileModal isOpen={userProfileModalOpen} userId={basicDetails?.userId} onClose={userProfileModalOnClose}></UserProfileModal>
    </>
  );
};
export default MyProfile;
